export default {
	ERASE: 'erase',
	IMAGE: 'image',
	WEBCAM: 'webcam',
	NONE: 'none',
	PENCIL: 'pencil',
	MARKER: 'marker',
	TEXT: 'text',
}
